module.exports = {
      id: "service-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#service-usage",
      toString: function () {
        return this.url;
      }
    }